"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gmailUpdateOrgSignature = exports.gmailUpdateOrgSignatureResultSchema = exports.gmailUpdateOrgSignatureArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.gmailUpdateOrgSignatureArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('update-org-signature', zod_1.z.object({
    signature: zod_1.z.string().describe('The new signature content'),
    email: zod_1.z.string().describe('The email address that will have the signature updated'),
    credentials: zod_1.z
        .object({})
        .describe('Service Account credentials from connected Google Cloud account'),
}));
exports.gmailUpdateOrgSignatureResultSchema = (0, common_1.PipedreamNodeResultSchema)(zod_1.z.object({}) // Empty output
);
exports.gmailUpdateOrgSignature = (0, common_1.createToolMetadata)({
    id: 'gmailUpdateOrgSignature',
    displayName: 'Gmail Update Org Signature',
    displayDescription: 'Update the signature for a specific email address in an organization',
    category: 'communication',
    color: common_1.BRAND_COLORS.GMAIL,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GMAIL),
    icon: 'gmail',
    argsSchema: exports.gmailUpdateOrgSignatureArgsSchema,
}, exports.gmailUpdateOrgSignatureResultSchema);
